<app-dialog-header
	[title]="'dialog.vehicleInAuctions.subtitle'"
	variant="info"
	(closeClick)="close()"
></app-dialog-header>
<mat-dialog-content>
	<div class="rich-table-container">
		<!-- floatthead -->
		<table
			class="table table-striped rich-table tabella"
			[mfData]="vehicles"
			#mf="appDataTable"
			[mfRowsOnPage]="tableData.rowsOnPage"
			[(mfSortBy)]="tableData.orderBy"
			[(mfSortOrder)]="tableData.sortOrder"
		>
			<thead class="rich-table-thead">
				<tr class="rich-table-subheader">
					<th
						class="rich-table-subheadercell"
						scope="col"
					>
						<app-default-sorter by="licensePlate">
							{{ "dialog.vehicleInAuctions.licensePlate" | translate }}
						</app-default-sorter>
					</th>
					<th
						class="rich-table-subheadercell"
						scope="col"
					>
						<app-default-sorter by="frame">
							{{ "dialog.vehicleInAuctions.frame" | translate }}
						</app-default-sorter>
					</th>
					<th
						class="rich-table-subheadercell"
						scope="col"
					>
						<app-default-sorter by="endAuction">
							{{ "dialog.vehicleInAuctions.endAuction" | translate }}
						</app-default-sorter>
					</th>
					<th
						class="rich-table-subheadercell"
						scope="col"
					>
						<app-default-sorter by="idAuction">
							{{ "dialog.vehicleInAuctions.idAuction" | translate }}
						</app-default-sorter>
					</th>
					<th
						class="rich-table-subheadercell"
						scope="col"
					>
						<app-default-sorter by="idLot">
							{{ "dialog.vehicleInAuctions.idLot" | translate }}
						</app-default-sorter>
					</th>
				</tr>
			</thead>
			<tbody>
				@for (element of mf.data; track element) {
					<tr class="rich-table-row rich-table-firstrow altclr">
						<td class="rich-table-cell text-center">{{ element?.licensePlate }}</td>
						<td class="rich-table-cell text-center">{{ element?.frame }}</td>
						<td class="rich-table-cell text-center">{{ element?.endAuction | ckDate: false }}</td>
						<td class="rich-table-cell text-center">{{ element?.idAuction != -1 ? element?.idAuction : "" }}</td>
						<td class="rich-table-cell text-center">{{ element?.idLot != -1 ? element?.idLot : "" }}</td>
					</tr>
				}
			</tbody>
			<tfoot>
				<tr>
					<td [attr.colspan]="tableData.col">
						<app-bootstrap-paginator [rowsOnPageSet]="rowsOnPageSet"></app-bootstrap-paginator>
					</td>
				</tr>
			</tfoot>
		</table>
	</div>
</mat-dialog-content>
